/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EquipmentGeometryGeometriesInnerOneOf4
 */
export interface EquipmentGeometryGeometriesInnerOneOf4 {
    /**
     * 
     * @type {EquipmentGeometryGeometriesInnerOneOf4TypeEnum}
     * @memberof EquipmentGeometryGeometriesInnerOneOf4
     */
    type: EquipmentGeometryGeometriesInnerOneOf4TypeEnum;
    /**
     * 
     * @type {Array<Array<Array<number>>>}
     * @memberof EquipmentGeometryGeometriesInnerOneOf4
     */
    coordinates: Array<Array<Array<number>>>;
}


/**
 * @export
 */
export const EquipmentGeometryGeometriesInnerOneOf4TypeEnum = {
    MultiLineString: 'MultiLineString'
} as const;
export type EquipmentGeometryGeometriesInnerOneOf4TypeEnum = typeof EquipmentGeometryGeometriesInnerOneOf4TypeEnum[keyof typeof EquipmentGeometryGeometriesInnerOneOf4TypeEnum];


/**
 * Check if a given object implements the EquipmentGeometryGeometriesInnerOneOf4 interface.
 */
export function instanceOfEquipmentGeometryGeometriesInnerOneOf4(value: object): value is EquipmentGeometryGeometriesInnerOneOf4 {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (value['type'] !== 'MultiLineString') return false;
    
    if (!('coordinates' in value) || value['coordinates'] === undefined) return false;
    return true;
}

export function EquipmentGeometryGeometriesInnerOneOf4FromJSON(json: any): EquipmentGeometryGeometriesInnerOneOf4 {
    return EquipmentGeometryGeometriesInnerOneOf4FromJSONTyped(json, false);
}

export function EquipmentGeometryGeometriesInnerOneOf4FromJSONTyped(json: any, ignoreDiscriminator: boolean): EquipmentGeometryGeometriesInnerOneOf4 {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'coordinates': json['coordinates'],
    };
}

export function EquipmentGeometryGeometriesInnerOneOf4ToJSON(json: any): EquipmentGeometryGeometriesInnerOneOf4 {
    return EquipmentGeometryGeometriesInnerOneOf4ToJSONTyped(json, false);
}

export function EquipmentGeometryGeometriesInnerOneOf4ToJSONTyped(value?: EquipmentGeometryGeometriesInnerOneOf4 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'coordinates': value['coordinates'],
    };
}

